import axios, { AxiosPromise, AxiosRequestConfig } from 'axios'
import { CHAMADA_PAINEL_API_ROUTES } from 'view/chamada-painel/constants-chamadaPainel'
import {
  Chamada,
  DispositivoPainelLoginRequest,
  DispositivoPainelStatusResponse,
  GerarPinPareamentoResponse,
  VerificarStatusPareamentoResponse,
} from 'view/chamada-painel/model-chamadaPainel'

export class ChamadaPainel {
  gerarPin(config?: AxiosRequestConfig): AxiosPromise<GerarPinPareamentoResponse> {
    return axios.post(CHAMADA_PAINEL_API_ROUTES.GERAR_PIN, {}, config)
  }

  verificarStatusPareamento(
    uuid: string,
    config?: AxiosRequestConfig
  ): AxiosPromise<VerificarStatusPareamentoResponse> {
    return axios.get(CHAMADA_PAINEL_API_ROUTES.STATUS_PAREAMENTO(uuid), config)
  }

  status(config?: AxiosRequestConfig): AxiosPromise<DispositivoPainelStatusResponse> {
    return axios.get(CHAMADA_PAINEL_API_ROUTES.STATUS, config)
  }

  login(data: DispositivoPainelLoginRequest, config?: AxiosRequestConfig): AxiosPromise<void> {
    return axios.post(CHAMADA_PAINEL_API_ROUTES.LOGIN, data, config)
  }

  chamadas(from: Date, config?: AxiosRequestConfig): AxiosPromise<Chamada[]> {
    return axios.get(CHAMADA_PAINEL_API_ROUTES.CHAMADAS, { ...config, params: { from: from.toISOString() } })
  }
}
